import type { PersonaInput } from './buildPersonaString.js';

const PERSONA_KEY = 'notion-training:last-persona';
const SKIPPED_KEY = 'notion-training:plan-skipped';

export function loadLastPersona(): PersonaInput | null {
  try {
    const raw = localStorage.getItem(PERSONA_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PersonaInput;
  } catch {
    return null;
  }
}

export function saveLastPersona(input: PersonaInput): void {
  try {
    localStorage.setItem(PERSONA_KEY, JSON.stringify(input));
  } catch {
    /* quota or unavailable — non-fatal */
  }
}

export function isPlanSkipped(): boolean {
  try {
    return localStorage.getItem(SKIPPED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setPlanSkipped(): void {
  try {
    localStorage.setItem(SKIPPED_KEY, 'true');
  } catch { /* non-fatal */ }
}

export function clearPlanSkipped(): void {
  try {
    localStorage.removeItem(SKIPPED_KEY);
  } catch { /* non-fatal */ }
}
